import { auth } from "../firebase";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8080";

async function getHeaders() {
  const user = auth.currentUser;

  if (!user) {
    return null;
  }

  const token = await user.getIdToken();

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function api(path, options = {}) {
  const headers = await getHeaders();

  if (!headers) {
    return { ok: false, unauthenticated: true };
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      ...headers,
      ...(options.headers || {}),
    },
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.message || data?.error || "Request failed");
  }

  return data;
}

export async function apiBeerFinder(payload) {
  return api("/api/beer-finder", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function apiGetMyBeerFinder() {
  return api("/api/beer-finder/me", {
    method: "GET",
  });
}